// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4cb2520c","453":"f5b944b9","732":"152e59b9"}[chunkId] + ".chunk.js";
};